var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _path7, _g4, _path8, _g5, _path9, _g6, _path10, _path11, _path12, _path13, _path14, _g7, _path15, _g8, _path16, _g9, _path17, _path18, _path19, _g10, _path20, _g11, _path21, _g12, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlide6Ill3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 220,
    viewBox: "0 0 359 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.82 128.786L359 142.661V69.3604L337.82 79.1582V128.786Z",
    fill: "url(#paint0_linear_7761_85527)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M341.105 184.953V185.3L317.843 198.987V21.4382L341.105 32.8493C346.479 32.8493 350.809 66.8943 350.809 108.901C350.809 150.908 346.479 184.953 341.105 184.953Z",
    fill: "url(#paint1_linear_7761_85527)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7761_85527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 317,
    y: 21,
    width: 34,
    height: 178
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M341.103 184.95V185.296L317.841 198.984V21.4348L341.103 32.8458C346.477 32.8458 350.807 66.8909 350.807 108.898C350.807 150.905 346.477 184.95 341.103 184.95Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7761_85527)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M324.701 41.7637L368.89 52.1009V-9.25439H324.701V41.7637Z",
    fill: "url(#paint2_linear_7761_85527)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7761_85527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 317,
    y: 21,
    width: 34,
    height: 178
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M341.103 184.95V185.296L317.841 198.984V21.4348L341.103 32.8458C346.477 32.8458 350.807 66.8909 350.807 108.898C350.807 150.905 346.477 184.95 341.103 184.95Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7761_85527)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M323.312 143.288L352.329 137.345V69.6063L323.312 64.9004V143.288Z",
    fill: "url(#paint3_linear_7761_85527)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7761_85527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 317,
    y: 21,
    width: 34,
    height: 178
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M341.103 184.95V185.296L317.841 198.984V21.4348L341.103 32.8458C346.477 32.8458 350.807 66.8909 350.807 108.898C350.807 150.905 346.477 184.95 341.103 184.95Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7761_85527)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M324.26 220.739H355.296L352.58 171.146L324.26 178.762V220.739Z",
    fill: "url(#paint4_linear_7761_85527)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M321.634 219.914H295.714V0.96167H321.634C328.651 0.96167 334.341 49.9856 334.341 110.425C334.341 170.865 328.651 219.919 321.634 219.919V219.914Z",
    fill: "url(#paint5_linear_7761_85527)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7761_85527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 0,
    width: 40,
    height: 220
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M321.634 219.91H295.714V0.958008H321.634C328.651 0.958008 334.341 49.9819 334.341 110.422C334.341 170.862 328.651 219.915 321.634 219.915V219.91Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7761_85527)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M350.339 55.1633H304.378V150.212H350.339V55.1633Z",
    fill: "url(#paint6_linear_7761_85527)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_7761_85527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 0,
    width: 40,
    height: 220
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M321.634 219.91H295.714V0.958008H321.634C328.651 0.958008 334.341 49.9819 334.341 110.422C334.341 170.862 328.651 219.915 321.634 219.915V219.91Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_7761_85527)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M340.729 -84.6436H294.769V10.4055H340.729V-84.6436Z",
    fill: "url(#paint7_linear_7761_85527)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_7761_85527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 0,
    width: 40,
    height: 220
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M321.634 219.91H295.714V0.958008H321.634C328.651 0.958008 334.341 49.9819 334.341 110.422C334.341 170.862 328.651 219.915 321.634 219.915V219.91Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_7761_85527)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M338.009 187.545H292.048V317.045H338.009V187.545Z",
    fill: "url(#paint8_linear_7761_85527)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M295.714 219.917C302.732 219.917 308.422 170.908 308.422 110.453C308.422 49.9976 302.732 0.989014 295.714 0.989014C288.696 0.989014 283.007 49.9976 283.007 110.453C283.007 170.908 288.696 219.917 295.714 219.917Z",
    fill: "url(#paint9_linear_7761_85527)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M292.177 10.1284H59.9775V215.364H292.177C299.194 215.364 304.884 169.403 304.884 112.729C304.884 56.0546 299.164 10.1284 292.177 10.1284Z",
    fill: "url(#paint10_linear_7761_85527)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8155 195.734H299.634C299.634 195.734 296.976 212.36 292.74 215.364H67.8105V195.734H67.8155Z",
    fill: "url(#paint11_linear_7761_85527)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4207 0.957346H48.501V219.91H74.4207C81.4375 219.91 87.1282 170.886 87.1282 110.446C87.0985 49.9763 81.4375 0.952393 74.4207 0.952393V0.957346Z",
    fill: "url(#paint12_linear_7761_85527)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_7761_85527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 0,
    width: 40,
    height: 220
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4197 0.956125H48.5V219.908H74.4197C81.4366 219.908 87.1272 170.885 87.1272 110.445C87.0976 49.9751 81.4366 0.951172 74.4197 0.951172V0.956125Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_7761_85527)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M95.6981 58.3594H49.7373V153.408H95.6981V58.3594Z",
    fill: "url(#paint13_linear_7761_85527)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_7761_85527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 0,
    width: 40,
    height: 220
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4197 0.956125H48.5V219.908H74.4197C81.4366 219.908 87.1272 170.885 87.1272 110.445C87.0976 49.9751 81.4366 0.951172 74.4197 0.951172V0.956125Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_7761_85527)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.0888 -81.4441H40.1279V13.6049H86.0888V-81.4441Z",
    fill: "url(#paint14_linear_7761_85527)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_7761_85527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 0,
    width: 40,
    height: 220
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4197 0.956125H48.5V219.908H74.4197C81.4366 219.908 87.1272 170.885 87.1272 110.445C87.0976 49.9751 81.4366 0.951172 74.4197 0.951172V0.956125Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_7761_85527)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M92.2186 190.767H46.2578V320.267H92.2186V190.767Z",
    fill: "url(#paint15_linear_7761_85527)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5015 219.917C55.5197 219.917 61.209 170.908 61.209 110.453C61.209 49.9976 55.5197 0.989014 48.5015 0.989014C41.4833 0.989014 35.7939 49.9976 35.7939 110.453C35.7939 170.908 41.4833 219.917 48.5015 219.917Z",
    fill: "url(#paint16_linear_7761_85527)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.059 23.1479L26.0918 32.8221V185.273L43.8566 195.734C48.5032 195.734 54.1938 151.45 54.1938 109.443C54.1938 67.4362 49.7056 23.1529 45.059 23.1529V23.1479Z",
    fill: "url(#paint17_linear_7761_85527)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_7761_85527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 29,
    height: 173
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.06 23.147L26.0928 32.8211V185.272L43.8576 195.733C48.5041 195.733 54.1948 151.449 54.1948 109.442C54.1948 67.4352 49.7066 23.1519 45.06 23.1519V23.147Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_7761_85527)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.3729 36.4589L9.18359 46.7912V-14.5889H53.3729V36.4589Z",
    fill: "url(#paint18_linear_7761_85527)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_7761_85527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 29,
    height: 173
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.06 23.147L26.0928 32.8211V185.272L43.8576 195.733C48.5041 195.733 54.1948 151.449 54.1948 109.442C54.1948 67.4352 49.7066 23.1519 45.06 23.1519V23.147Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_7761_85527)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.262 153.407L28.2148 147.464V79.7257L57.262 74.9851V153.407Z",
    fill: "url(#paint19_linear_7761_85527)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_7761_85527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 29,
    height: 173
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.06 23.147L26.0928 32.8211V185.272L43.8576 195.733C48.5041 195.733 54.1948 151.449 54.1948 109.442C54.1948 67.4352 49.7066 23.1519 45.06 23.1519V23.147Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_7761_85527)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.474 225.729H17.4326L20.1542 176.136L48.474 183.752V225.729Z",
    fill: "url(#paint20_linear_7761_85527)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M45.0581 23.1484L33.7411 28.9331C34.9733 34.0547 36.7101 39.1417 37.1852 44.2633C40.6639 84.4691 43.821 123.631 38.1353 164.188C36.9972 172.754 33.8698 180.246 31.2422 188.336L43.821 195.734C48.4676 195.734 54.1582 151.451 54.1582 109.444C54.1582 67.4367 49.6997 23.1534 45.0532 23.1534L45.0581 23.1484Z",
    fill: "url(#paint21_linear_7761_85527)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0957 185.271C29.919 185.271 33.0185 151.15 33.0185 109.061C33.0185 66.9707 29.919 32.8501 26.0957 32.8501C22.2723 32.8501 19.1729 66.9707 19.1729 109.061C19.1729 151.15 22.2723 185.271 26.0957 185.271Z",
    fill: "url(#paint22_linear_7761_85527)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4827 108.27C24.4827 120.25 25.9672 130.681 24.735 132.987C24.547 133.304 21.954 133.081 21.766 133.081C20.2468 133.081 19.0146 121.987 19.0146 108.27C19.0146 94.5527 20.2468 83.4584 21.766 83.4584C21.954 83.4584 24.3243 83.1417 24.5173 83.4584C25.7494 85.799 24.4876 96.2896 24.4876 108.27H24.4827Z",
    fill: "url(#paint23_linear_7761_85527)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4828 133.08C26.0023 133.08 27.2341 121.972 27.2341 108.269C27.2341 94.5659 26.0023 83.4575 24.4828 83.4575C22.9633 83.4575 21.7314 94.5659 21.7314 108.269C21.7314 121.972 22.9633 133.08 24.4828 133.08Z",
    fill: "url(#paint24_linear_7761_85527)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4822 83.4587L0.111328 59.3748V153.409L24.4822 133.086V83.4587Z",
    fill: "url(#paint25_linear_7761_85527)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.8735 208.188C49.1115 208.188 50.1151 205.824 50.1151 202.908C50.1151 199.992 49.1115 197.628 47.8735 197.628C46.6355 197.628 45.6318 199.992 45.6318 202.908C45.6318 205.824 46.6355 208.188 47.8735 208.188Z",
    fill: "url(#paint26_linear_7761_85527)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M56.756 139.915C57.4556 139.915 58.0228 137.551 58.0228 134.635C58.0228 131.719 57.4556 129.355 56.756 129.355C56.0564 129.355 55.4893 131.719 55.4893 134.635C55.4893 137.551 56.0564 139.915 56.756 139.915Z",
    fill: "url(#paint27_linear_7761_85527)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.4582 69.929C56.1578 69.929 56.725 67.5651 56.725 64.6491C56.725 61.733 56.1578 59.3691 55.4582 59.3691C54.7585 59.3691 54.1914 61.733 54.1914 64.6491C54.1914 67.5651 54.7585 69.929 55.4582 69.929Z",
    fill: "url(#paint28_linear_7761_85527)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.1955 21.5079C46.8952 21.5079 47.4623 19.144 47.4623 16.2279C47.4623 13.3119 46.8952 10.948 46.1955 10.948C45.4959 10.948 44.9287 13.3119 44.9287 16.2279C44.9287 19.144 45.4959 21.5079 46.1955 21.5079Z",
    fill: "url(#paint29_linear_7761_85527)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7761_85527",
    x1: 352.737,
    y1: 101.008,
    x2: 331.518,
    y2: 101.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1462F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FF6B5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7761_85527",
    x1: 338.007,
    y1: -4.98687,
    x2: 336.271,
    y2: 170.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7761_85527",
    x1: 340.515,
    y1: 427.171,
    x2: 340.515,
    y2: 427.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7761_85527",
    x1: 331.522,
    y1: 46.1204,
    x2: 331.522,
    y2: 144.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7761_85527",
    x1: 333.484,
    y1: 159.237,
    x2: 333.484,
    y2: 221.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7761_85527",
    x1: 317.059,
    y1: 218.304,
    x2: 317.059,
    y2: -9.62061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7761_85527",
    x1: 330.32,
    y1: 53.0512,
    x2: 330.32,
    y2: 151.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7761_85527",
    x1: 320.693,
    y1: -87.0271,
    x2: 320.693,
    y2: 11.9094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7761_85527",
    x1: 317.97,
    y1: 185.208,
    x2: 317.97,
    y2: 320.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7761_85527",
    x1: 271.263,
    y1: 427.176,
    x2: 310.227,
    y2: 427.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303256",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#2A3861",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#224272",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1D487C",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7761_85527",
    x1: 185.116,
    y1: 9.61834,
    x2: 185.116,
    y2: 213.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF6B5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1462F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7761_85527",
    x1: 186.414,
    y1: 215.789,
    x2: 186.414,
    y2: 195.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF6B5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1462F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7761_85527",
    x1: 70.2797,
    y1: -3.0481,
    x2: 70.2797,
    y2: 224.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7761_85527",
    x1: 75.1877,
    y1: 56.2763,
    x2: 75.1877,
    y2: 155.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7761_85527",
    x1: 65.5606,
    y1: -83.8067,
    x2: 65.5606,
    y2: 15.1298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7761_85527",
    x1: 71.7033,
    y1: 188.426,
    x2: 71.7033,
    y2: 323.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7761_85527",
    x1: 36.9319,
    y1: 207.045,
    x2: 62.8061,
    y2: 27.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#95AAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BBC8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C2CEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7761_85527",
    x1: 42.555,
    y1: -17.3863,
    x2: 42.555,
    y2: 199.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7761_85527",
    x1: 33.6721,
    y1: -29.5825,
    x2: 33.6721,
    y2: 47.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7761_85527",
    x1: 45.152,
    y1: 56.25,
    x2: 45.152,
    y2: 154.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7761_85527",
    x1: 35.3506,
    y1: 164.242,
    x2: 35.3506,
    y2: 226.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7761_85527",
    x1: 33.677,
    y1: 427.176,
    x2: 56.6376,
    y2: 427.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#678ADC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#00112C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7761_85527",
    x1: 16.5625,
    y1: 196.548,
    x2: 40.3212,
    y2: 20.8692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7761_85527",
    x1: 21.3099,
    y1: 136.541,
    x2: 29.1165,
    y2: 78.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7761_85527",
    x1: 22.979,
    y1: 136.356,
    x2: 30.7192,
    y2: 79.1417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF6B5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1462F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7761_85527",
    x1: 2.44381,
    y1: 105.774,
    x2: 29.1795,
    y2: 105.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1462F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FF6B5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7761_85527",
    x1: 48.0611,
    y1: 202.494,
    x2: 52.5328,
    y2: 202.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7761_85527",
    x1: 57.9138,
    y1: 134.081,
    x2: 60.4569,
    y2: 134.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7761_85527",
    x1: 56.6361,
    y1: 63.9597,
    x2: 59.1792,
    y2: 63.9438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_7761_85527",
    x1: 47.3418,
    y1: 15.4406,
    x2: 49.888,
    y2: 15.4247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide6Ill3);
export default __webpack_public_path__ + "static/media/slide_6_ill_3.cb28f63273660642389dce06a48146dd.svg";
export { ForwardRef as ReactComponent };